import { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  REASONS,
  useReauthManagement
} from '../../../hooks/useReauthManagement';
import { useUser } from '../../../state/user/index.ts';
import { useToggles } from '../../../state/toggles/index.ts';
import { useApp, useAppDispatchers } from '../../../state/app/index.ts';
import { AnalyticsContext } from '../../../ModularReduxAnalytics';

const useRedirect = () => {
  const { segment } = useContext(AnalyticsContext);
  const history = useHistory();
  const { registeredUserPhone } = useUser();
  const { unauthorizedCleanStateEnabled } = useToggles();

  const { clearError, registrationReauth, createError } = useAppDispatchers();
  const { message, errorCode, appOs, appVersion } = useApp();
  const { getReauthAttemptsByReason } = useReauthManagement();

  useEffect(() => {
    if (
      [
        REASONS.UNAUTHORIZED,
        REASONS.INVALID_TOKEN,
        REASONS.INVALID_IP
      ].includes(message) ||
      errorCode === 401
    ) {
      clearError();
      if (
        message !== REASONS.INVALID_IP ||
        getReauthAttemptsByReason(REASONS.INVALID_IP) < 1
      ) {
        segment.trackEvent('Registration Error Triggered', {
          eventProps: {
            appOs,
            appVersion,
            message,
            errorCode
          }
        });
        registrationReauth(message);
      }
      if (registeredUserPhone) {
        createError({
          message: 'Your session has expired. Please log in again.',
          registrationStep: 'webreg'
        });
        history.push(`/?phoneNumber=${registeredUserPhone}`);
      } else if (unauthorizedCleanStateEnabled) {
        window.location.href = `https://greenlight.com/`;
      } else {
        history.push('/');
      }
    }
  }, [message]);
};

export default useRedirect;
